module.exports = {
      id: "black-zoom-out-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#black-zoom-out",
      toString: function () {
        return this.url;
      }
    }